import { mockAuthService } from "./auth";
import {
  mockAdapterService,
  mockChannelService,
  mockClientService,
  mockCountryService,
  mockCurrencyService,
  mockDelegationService,
  mockDepositService,
  mockDisclaimerService,
  mockUsersGuideService,
  mockI18nService,
  mockServicepointService,
  mockSolCustomerService,
  mockSolService,
  mockSubclientService,
  mockUserService,
  mockReportService,
  mockSolServiceApi,
  mockOrderPendingService,
  mockApprovalsService,
} from "./backend";
import { IProviderMock } from "./provider.types";

export const mockProvider = (): IProviderMock => ({
  adapter: mockAdapterService(),
  auth: mockAuthService(),
  client: mockClientService(),
  channel: mockChannelService(),
  country: mockCountryService(),
  currency: mockCurrencyService(),
  delegation: mockDelegationService(),
  deposit: mockDepositService(),
  i18n: mockI18nService(),
  servicepoint: mockServicepointService(),
  sol: mockSolService(),
  solCustomer: mockSolCustomerService(),
  solServiceApi: mockSolServiceApi(),
  subclient: mockSubclientService(),
  user: mockUserService(),
  disclaimer: mockDisclaimerService(),
  usersGuide: mockUsersGuideService(),
  report: mockReportService(),
  order_pending: mockOrderPendingService(),
  approvals: mockApprovalsService(),
});
